module.exports = __webpack_public_path__ + "img/coliseum.a6f9cde1.png";